import { FC } from "react"
import { useGetQuickStatusQuery } from "../../../../../redux/queries"
import Status from "../../../status"
import { Loader2 } from "lucide-react"

interface Props {
  integrationId: string
  className?: string
}

const IntegrationStatusTag: FC<Props> = ({ integrationId, className }) => {
  const { data: status, isLoading } = useGetQuickStatusQuery(
    { integrationID: integrationId ?? "" },
    { skip: !integrationId }
  )

  if (isLoading) return <Loader2 className="animate-spin h-4 w-4 ml-2" />
  if (!status) return null

  const StatusComponent =
    status.status === "active"
      ? Status.Active
      : status.status === "idle"
      ? Status.Idle
      : Status.Initial

  return <StatusComponent className={className} />
}

export default IntegrationStatusTag
